import { useRoute } from 'shared/src/hooks/useRoute';

export type GoodsDetailExtras = {
  logging_analytics?: string;
  goods_name: string;
  market_name: string;
  cover_image: string;
  market_image: string;
  discount_rate: number;
  original_price: number;
  price: number;
  from?: string;
  coupon_sno?: number;
  /** true면 타 마켓 연관상품(component 176) 영역을 미노출한다 (기획전 이벤트 연관상품 off 실험) */
  same_market_recommend_only?: boolean;
  /** 메타피드 click → PDP launch 시 전달되는 광고 정보 (JSON string) */
  ad?: string;
  /** 어필리에이트 링크 진입 시 deeplink query에서 전달되는 고유 id */
  uid?: string;
  /** 트래킹 링크 진입 시 deeplink query에서 전달되는 airbridge referrer raw string */
  airbridge_referrer?: string;
  /** 트래킹 링크 진입 시 deeplink query에서 전달되는 tracking content */
  tracking_content?: string;
  /** 트래킹 링크 진입 시 deeplink query에서 전달되는 short id */
  short_id?: string;
};

export type GoodsRouteParams = {
  RecentlyViewedGoods: {
    instanceId?: string;
  };
  GoodsDetail: {
    instanceId?: string;
    goodsId: number;
    extras?: GoodsDetailExtras;
  };
  GoodsList: {
    instanceId?: string;
    type: string;
    goodsSno: number;
    landingFrom?: string;
    position?: string;
  };
};

export const useGoodsRoute = <Key extends keyof GoodsRouteParams>() =>
  useRoute<GoodsRouteParams, Key>();
